// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {CSSProperties, useContext} from 'react';
import {Settings_context} from '../../../settings_ctx';
import {use_screen} from '../../../lib/screen_util';
import {use_translation_v} from '../../../lib/trans_v';
import styles from './title.module.less';
import cn from 'classnames';
import {Editor} from '../../../../../shared/editor/editor';

interface i_title {
    title: string;
    subtitle: string;
    description?: string;
    description_size?: string;
    max_width?: string;
    max_width_unit?: string;
    gradient?: boolean;
}

interface i_title_editor_props {
    value: i_title;
    on_change: (new_value: i_title)=>void;
}

export const Title = (props: i_title)=>{
    const {theme} = useContext(Settings_context);
    const {width} = use_screen();
    const {T} = use_translation_v({no_defaults: true});
    const is_tablet = width < 1440;
    const h_type = props.gradient ? is_tablet ? 'H2' : 'H1'
      : is_tablet ? 'H3' : 'H2';
    const title_width = {
      '--title_width': props?.max_width ?
        `${props?.max_width}${props?.max_width_unit||'px'}` : '100%'
    } as CSSProperties;
    const desc_size = props?.description_size ? props.description_size : 'u1';
    return <div className={cn(props.gradient && styles.gradient)}>
      <div className={styles.p_title_wrapper}>
        <p className={cn(theme[h_type], theme.color_n700, styles.title,
          props.gradient && styles.title_m)} style={title_width}>
          <T>{props.title}</T></p>
        <p className={cn(theme.H4, theme.light, theme.color_n700)}>
          <T>{props.subtitle}</T></p>
        {props.description && <p className={cn(theme[desc_size], theme.med,
          styles.description)}>
          <T>{props.description}</T></p>}
      </div>
    </div>;
};

export const Title_editor = (props: i_title_editor_props)=>{
  const {value = {title: '', subtitle: '', description: '',
    description_size: '', gradient: '', max_width: '',
    max_width_unit: ''}, on_change} = props;
  type editor_key = keyof i_title;
  type editor_type = 'text' | 'textarea' | 'number' | 'boolean' | 'selector';
  const title_desc = 'Gradient (will enabled full screen'
    +' title and no spacer required above)';
  const editors = [
      ['gradient', title_desc, 'boolean'],
      ['title', 'Title', 'text'],
      ['max_width', 'Title width', 'text'],
      ['max_width_unit', 'Title width unit(px/rem/em)', 'text'],
      ['subtitle', 'Subtitle', 'text'],
      ['description', 'Description', 'text'],
      ['description_size', 'Description size', 'text'],
  ].map(([key, label, type])=>({key: key as editor_key, label,
      type: type as editor_type}));
  return <Editor
    value={value}
    editors={editors}
    on_change={on_change}
    title="Title"
  />;
};
